import { Tag } from 'antd';
import { linkCell } from 'utils/cell-formatter';

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/nhsv/webhook-configs' }),
  },
  {
    accessorKey: 'event_id',
    header: 'Event ID',
    cell: ({ getValue }) => getValue() ?? '-',
  },
  {
    accessorKey: 'target_url',
    header: 'Target URL',
    cell: ({ getValue }) => (
      <span className="font-mono text-xs break-all">{getValue() || '-'}</span>
    ),
  },
  {
    accessorKey: 'timeout_ms',
    header: 'Timeout (ms)',
    cell: ({ getValue }) => getValue() ?? '-',
  },
  {
    accessorKey: 'active',
    header: 'Status',
    cell: ({ getValue }) =>
      getValue() ? (
        <Tag color="green">Active</Tag>
      ) : (
        <Tag color="default">Inactive</Tag>
      ),
  },
  {
    accessorKey: 'updated_at',
    header: 'Updated At',
    cell: ({ getValue }) => getValue() || '-',
  },
];
